<div class="cart_section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 offset-lg-1">
                <div class="cart_container">
                    <div class="cart_title">My Favourites<small> ({{favLength}} item in your favourites) </small></div>
                    <div class="cart_items" *ngIf="favLength">
                        <ul class="cart_list px-0">
                            <li class="cart_item clearfix" *ngFor="let cart of favProduct">
                                <div class="cart_item_image"><img src="{{cart.image}}" class="img-fluid" alt=""></div>
                                <div class="cart_item_info d-flex flex-md-row flex-column justify-content-between">
                                    <div class="cart_item_name cart_info_col">
                                        <div class="cart_item_title">Name</div>
                                        <div class="cart_item_text">{{cart.title}}</div>
                                    </div>
                                    <div class="cart_item_quantity cart_info_col">
                                        <div class="cart_item_title">Rating</div>
                                        <div class="cart_item_text">{{cart.rating.rate}}</div>
                                    </div>
                                    <div class="cart_item_quantity cart_info_col">
                                        <div class="cart_item_title">Quantity</div>
                                        <div class="cart_item_text">1</div>
                                    </div>
                                    <div class="cart_item_price cart_info_col">
                                        <div class="cart_item_title">Price</div>
                                        <div class="cart_item_text">{{cart.price}}</div>
                                    </div>
                                    <div class="cart_item_total cart_info_col">
                                        <div class="cart_item_title">Total</div>
                                        <div class="cart_item_text">{{cart.price}}</div>
                                    </div>
                                    <div class="cart_item_total cart_info_col text-center">
                                        <div class="cart_item_title pt-1 fs-5 pointer" mat-button (click)="removeProduct(cart)">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </div>
                                        <button class="btn mat-button cart-btn py-0" (click)="addCart(cart)">Add to Cart</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="order_total" *ngIf="favLength">
                        <div class="order_total_content text-md-right">
                            <div class="order_total_title">Order Total:</div>
                            <div class="order_total_amount">₹ {{totalAmount}}</div>
                        </div>
                    </div>
                    <div class="cart_buttons" *ngIf="favLength"> <button type="button" class="button cart_button_clear">Continue Shopping</button> <button type="button" class="button cart_button_checkout">Add to Cart</button> </div>
                   -->
                   <div class="text-center" *ngIf="!favLength">
                    <p>No Favourites items in your Cart</p>
                </div> 
                </div>
            </div>
        </div>
    </div>
</div>